import api from './api';

export const roleApplicationService = {
  // Submit a new role application
  submitApplication: async (userId, roleId, householdId, notes) => {
    const response = await api.post('/role-applications', {
      userId,
      roleId,
      householdId,
      notes
    });
    return response.data;
  },

  // Submit a team supervisor application
  submitTeamSupervisorApplication: async (userId, roleId, householdId, notes, caregiverId) => {
    const response = await api.post('/role-applications/team-supervisor', {
      userId,
      roleId,
      householdId,
      notes,
      caregiverId
    });
    return response.data;
  },

  // Get all applications (admin only)
  getAllApplications: async () => {
    const response = await api.get('/role-applications');
    return response.data;
  },

  // Get pending applications
  getPendingApplications: async () => {
    const response = await api.get('/role-applications/pending');
    return response.data;
  },

  // Get applications by user
  getApplicationsByUser: async (userId) => {
    const response = await api.get(`/role-applications/user/${userId}`);
    return response.data;
  },

  // Get applications by household
  getApplicationsByHousehold: async (householdId) => {
    const response = await api.get(`/role-applications/household/${householdId}`);
    return response.data;
  },

  // Get application by ID
  getApplicationById: async (id) => {
    const response = await api.get(`/role-applications/${id}`);
    return response.data;
  },

  // Approve an application
  approveApplication: async (applicationId, adminUserId, adminNotes) => {
    const response = await api.put(`/role-applications/${applicationId}/approve`, {
      adminUserId,
      adminNotes
    });
    return response.data;
  },

  // Reject an application
  rejectApplication: async (applicationId, adminUserId, adminNotes) => {
    const response = await api.put(`/role-applications/${applicationId}/reject`, {
      adminUserId,
      adminNotes
    });
    return response.data;
  },

  // Update team supervisor application status
  updateTeamSupervisorStatus: async (applicationId, statusUpdates) => {
    const response = await api.put(`/role-applications/${applicationId}/team-supervisor-status`, statusUpdates);
    return response.data;
  },

  // Check if user has pending application for specific role
  checkPendingApplication: async (userId, roleId) => {
    const response = await api.get(`/role-applications/check-pending?userId=${userId}&roleId=${roleId}`);
    return response.data;
  },

  // Get pending applications count
  getPendingApplicationsCount: async () => {
    const response = await api.get('/role-applications/pending/count');
    return response.data;
  }
}; 